import Error from '../assets/common/icons/Error'
import Info from '../assets/common/icons/Info'

export const MessageTypes = {
  HELLO: 10,
  HELLO_RESP: 11,
  AUTHENTICATE: 20,
  AUTHENTICATE_RESP: 21,
  GET_TURN_CREDENTIALS: 30,
  GET_TURN_CREDENTIALS_RESP: 31,
  GET_RESOURCES: 40,
  GET_RESOURCES_RESP: 41,
  ALLOCATE: 50,
  ALLOCATE_RESP: 51,
  ERROR: 60,
  AUTH_ERROR: 61,
  SDP: 70,
  CANDIDATE: 71,
  INITIATE: 80,
  RESIZE: 81,
}

export const ConnectionDefines = {
  connection_to_signal: {
    step: 1,
    name: 'Contacting the signaling server',
    describe: 'Attempting to contact signaling server',
    error: 'signal_error',
  },
  allocate_remote_device: {
    step: 2,
    name: 'Contacting the remote host',
    describe: 'Exchanging websocket messages and starting the RTC connection',
    error: 'allocate_error',
  },
  establish_candidate: {
    step: 3,
    name: 'Requesting the remote desktop stream',
    describe: 'RTC connection is available but no video is being streamed yet',
    error: 'no_candidate',
  },
  establish_stream: {
    step: 4,
    name: 'Awaiting for the remote host desktop stream to start',
    describe: 'Awaiting for the remote host monitor stream to start',
    error: 'no_stream',
  },
}

export const ConnectErrors = {
  signal_error: {
    title: 'Authentication error',
    tips: {
      icon: Error,
      message: 'Authentication error.',
    },
    model: 'dialog',
    actions: {
      retry: true,
      cancel: true,
    },
  },
  allocate_error: {
    title: 'Connection error',
    tips: {
      icon: Error,
      message: 'Unable to contact the remote host.',
    },
    model: 'dialog',
    actions: {
      retry: true,
      cancel: true,
    },
  },
  no_candidate: {
    title: 'Connection error',
    tips: {
      icon: Error,
      message: 'Unable to retrieve the remote desktop stream.',
    },
    model: 'dialog',
    actions: {
      retry: true,
      cancel: true,
    },
  },
  no_stream: {
    title: 'No video output detected on the remote host',
    describe:
      'Be sure that the video cable is properly connected, the remote host is powered on and the monitor is not in sleep mode.',
    model: 'full',
    tips: {
      icon: Info,
      message: 'Your mouse and keyboard input might still be injected into the remote host.',
    },
  },
  connection_lost: {
    title: 'Connection error',
    model: 'dialog',
    tips: {
      icon: Error,
      message: 'Connection lost. Unable to retrieve the remote desktop stream.',
    },
    actions: {
      retry: true,
      cancel: true,
    },
  },
}

export const ConnectStepErrorMapping = {
  connection_to_signal: 'signal_error',
  allocate_remote_device: 'allocate_error',
  establish_candidate: 'no_candidate',
  establish_stream: 'connection_lost',
}
